import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 -960 960 960"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M320-80q-83 0-141.5-58.5T120-280q0-69 43-123t110-71q16-4 30 4.5t18 24.5-4.5 30-24.5 18q-41 10-66.5 42.5T200-280q0 50 35 85t85 35q41 0 73-25t43-64q5-16 19-24.5t30-3.5 24.5 19 3.5 30q-18 66-71.5 107T320-80m263.5-643.5Q560-747 560-780t23.5-56.5T640-860t56.5 23.5T720-780t-23.5 56.5T640-700t-56.5-23.5M440-320q-44 0-68-37.5t-6-78.5l74-164h-91l-11 28q-5 14-19 21.5t-29 2.5q-17-5-25-20.5t-1-32.5l12-31q9-23 29.5-35.5T350-680h208q45 0 68.5 36.5T632-566l-66 146h114q33 0 56.5 23.5T760-340v180q0 17-11.5 28.5T720-120t-28.5-11.5T680-160v-160z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }